import { ParsedData, QuestionScores } from '../types';

const STORAGE_KEY = 'ner-comparison-tool/state/v1';

export interface PersistedState {
  parsedData: ParsedData | null;
  currentFileName: string;
  scores: QuestionScores;
  searchTerm: string;
  labelFilters: string[]; // serialize Set<string> as array
  allowAddExamples?: boolean;
  allowBatchLabelRenaming?: boolean;
}

export function saveState(state: PersistedState) {
  try {
    const payload = JSON.stringify(state);
    localStorage.setItem(STORAGE_KEY, payload);
  } catch (e) {
    // Ignore storage errors (quota/disabled)
  }
}

export function loadState(): PersistedState | null {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    if (!raw) return null;
    return JSON.parse(raw) as PersistedState;
  } catch (e) {
    return null;
  }
}

export function clearState() {
  try {
    localStorage.removeItem(STORAGE_KEY);
  } catch (e) {
    // noop
  }
}


